import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Popover } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { getRevisionHistoryUrl } from '@Builder/QuoteDetailPage/FilesTab/logic'

import Box from '~/core/Box'
import Link from '~/core/Link'
import Text from '~/core/Text'
import { getUserIdentity } from '~/redux-modules/identity'
import colors from '~/styles/_colors.css'
import { PART_DFM_REPORT } from '../constants'

import styles from './styles.css'

type ParamsType = {
    id: string
}

type PartDFMReportFeedbackHelpPropsType = {
    qmrId?: string
    userId?: number
    isLocatedInAdminPanel?: boolean
}

const PartDFMReportFeedbackHelp = (
    props: PartDFMReportFeedbackHelpPropsType,
) => {
    const { qmrId, userId: userIdConverted, isLocatedInAdminPanel } = props

    const identity = useSelector(getUserIdentity)
    const { id: quoteId = '' } = useParams<ParamsType>()

    const isLocatedInOBO =
        userIdConverted && identity?.isAdmin && identity?.id !== userIdConverted

    const revisionHistoryLink = getRevisionHistoryUrl({
        isLocatedInAdminPanel,
        isObo: isLocatedInOBO,
        oboUserId: userIdConverted,
        qmrId,
        quoteId,
    })

    return (
        <Box>
            <Popover
                overlayClassName={styles.helpTooltip}
                overlayStyle={{
                    maxWidth: '384px',
                    width: '384px',
                }}
                placement="topRight"
                trigger="hover"
                content={
                    <>
                        <Box
                            padding="8px 12px"
                            borderBottom={`1px solid ${colors.blackAlpha15}`}
                        >
                            <Text
                                fontWeight={400}
                                color={colors.blackAlpha65}
                                style={{ marginTop: '4px' }}
                            >
                                Where can I find all DFM reports of this part?
                            </Text>
                        </Box>
                        <Box
                            padding="10px 10px"
                            color={colors.blackAlpha65}
                            style={{ fontWeight: 300 }}
                            direction="col"
                        >
                            <Text>
                                The DFM reports shown here are associated with
                                the current part revision. Please find the DFM
                                reports associated with all part revisions in{' '}
                                <Link
                                    to={revisionHistoryLink.url}
                                    from={{
                                        backUrlFor: revisionHistoryLink.backUrl,
                                        userId: userIdConverted,
                                    }}
                                    name={`${PART_DFM_REPORT}-revision-history`}
                                    data-test-target={`${PART_DFM_REPORT}-revisions-history-link`}
                                    placement={`${PART_DFM_REPORT}`}
                                >
                                    Revision history.
                                </Link>
                            </Text>
                        </Box>
                    </>
                }
            >
                <Box align="center">
                    <QuestionCircleOutlined
                        style={{
                            marginLeft: '15px',
                            color: colors.link,
                            fontSize: '14px',
                        }}
                    />
                </Box>
            </Popover>
        </Box>
    )
}

export default PartDFMReportFeedbackHelp
